import { atlassianApiGateway, wacUrl } from '@trello/config';
import { ProductKeys } from '@atlassiansox/product-store-react';

export const getTenantlessUrl = () => {
  const url = new URL(atlassianApiGateway);
  url.pathname = 'gpa-product-store/tenantless.html';
  return url.toString();
};

const utmQueryParams =
  'utm_source=trello&utm_medium=in_product_ad&utm_campaign=product_store';

export const setLocationToWacSoftware = (): void => {
  window.location.href = `${wacUrl}/software?${utmQueryParams}`;
};

export const setLocationToTryProductFreeEdition = (
  productKey: ProductKeys,
): void => {
  if (productKey === ProductKeys.OPSGENIE) {
    window.location.href = `${wacUrl}/software/opsgenie/try?${utmQueryParams}`;
    return;
  }
  const bundles: Record<string, string> = {
    [ProductKeys.JIRA_SOFTWARE]: 'jira-software',
    [ProductKeys.JIRA_SERVICE_DESK]: 'jira-service-desk',
    [ProductKeys.CONFLUENCE]: 'confluence',
  };
  const bundleKey = bundles[productKey];
  if (bundleKey) {
    window.location.href = `${wacUrl}/try/cloud/signup?bundle=${bundleKey}&edition=free&${utmQueryParams}`;
  } else {
    setLocationToWacSoftware();
  }
};
